import React from 'react';
import {
  SECONDS_IN_DAY, HOURS_IN_DAY, SECONDS_IN_HOUR, MINUTES_IN_HOUR, SECONDS_IN_MINUTE,
} from '@gamiphy/bl/time';
import { setPopupSessionStorage } from '@gamiphy/loyalty-station-desktop/store/popups/utils';
import { PopupsStore } from '@gamiphy/loyalty-station-desktop/store/popups';
import { PopupDto, PopupTriggerDetailsDtoOpenActionEnum } from '@coretava/api/core-service';
import { POPUP_AUTO_CLOSES_AFTER } from './constants';

export const useCountDown = (date?: null | Date): { days?: number, hours?: number, minutes?: number, seconds?: number } => {
  const [days, setDays] = React.useState<number>();
  const [hours, setHours] = React.useState<number>();
  const [minutes, setMinutes] = React.useState<number>();
  const [seconds, setSeconds] = React.useState<number>();

  if (date) {
    const x = setInterval(() => {
      // get total seconds between the times
      const newDate = new Date(date);
      const delta = Math.floor(Math.abs(newDate.getTime() - new Date().getTime()) / 1000);

      // calculate whole days
      const d = Math.floor(delta / SECONDS_IN_DAY);
      setDays(d);

      // calculate (and subtract) whole hours
      const h = Math.floor(delta / SECONDS_IN_HOUR) % HOURS_IN_DAY;
      setHours(h);
      const hDelta = delta - (h * SECONDS_IN_HOUR);

      // calculate (and subtract) whole minutes
      const m = Math.floor(hDelta / MINUTES_IN_HOUR) % MINUTES_IN_HOUR;
      setMinutes(m);
      const mDelta = hDelta - (m * MINUTES_IN_HOUR);

      // what's left is seconds
      const s = Math.floor(mDelta % SECONDS_IN_MINUTE); // in theory the modulus is not required
      setSeconds(s);

      if (delta <= 0) {
        clearInterval(x);
      }
    }, 1000);
  }

  return {
    days,
    hours,
    minutes,
    seconds,
  };
};

export const useAutoClose = (popup?: PopupDto): void => {
  React.useEffect(() => {
    let timeout: NodeJS.Timeout | undefined;
    if (popup?.triggerDetails.closeAction === PopupTriggerDetailsDtoOpenActionEnum.Auto) {
      timeout = setTimeout(() => {
        setPopupSessionStorage(popup);
        PopupsStore.closePopup();
      }, POPUP_AUTO_CLOSES_AFTER);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);
};
